<template>
	<div>
		<div class="btn-group" style="width: 100%">
			<button
				v-tooltip="tooltipMsg"
				type="button"
				:disabled="disabled"
				class="btn btn-white btn-block dropdown-toggle botaoSelect"
				data-toggle="dropdown"
				aria-haspopup="false"
				aria-expanded="false"
			>
				<div class="divSelect">
					{{ countActive > 9 ? '9+' : countActive }}
				</div>
				<small
					v-tooltip="label"
					style="
						height: 12px;
						display: flex;
						align-items: center;
						overflow: hidden;
					"
					>{{ label }}</small
				>
				<svg
					xmlns="http://www.w3.org/2000/svg"
					fill="none"
					viewBox="0 0 24 24"
					stroke-width="1.5"
					stroke="currentColor"
					style="width: 12px; height: 12px; margin-left: 3px"
				>
					<path
						stroke-linecap="round"
						stroke-linejoin="round"
						d="M19.5 8.25l-7.5 7.5-7.5-7.5"
					/>
				</svg>
			</button>
			<ul
				class="dropdown-menu"
				:style="{'max-height': _height - 140 + 'px'}"
				style="overflow: auto; width: 260px; border-radius: 3px; border: none"
			>
				<li>
					<input
						v-model="searchQuery"
						type="text"
						placeholder="Filtrar itens..."
						class="form-control"
					/>
				</li>
				<li :class="{active: it.active}" v-for="(it) in filteredList" :key="it[chaveValue]">
					<a @click.prevent.stop="ativaOuDesativa(it[chaveValue])" href="#">
						<i
							v-if="it.color"
							style="font-size: 12px"
							:style="{color: it.color}"
							class="fa fa-fw fa-circle"
						></i>
						{{ it[chaveLista] }}</a
					>
				</li>
			</ul>
		</div>
	</div>
</template>

<script>
import { findIndex } from 'lodash';

export default {
	props: {
		lista: {
			required: true,
			type: Array
		},
		label: {
			type: String,
			required: true
		},
		chaveLista: {
			type: String,
			required: true
		},
		chaveValue: {
			type: String,
			required: false,
			default: 'id'
		},
		disabled: {
			type: Boolean,
			required: false,
			default: false
		},
		tooltipMsg: {
			type: String,
			required: false,
			default: ''
		},
		filtroNome:{
			type: Boolean,
			required: false,
			default: false
		}
	},
	data() {
		return {
			listaDeIds: [],
			searchQuery: ''
		}
	},
	watch: {
		value(newValue) {
			this.listaDeIds = newValue
		},
		listaDeIds(newValue) {
			this.$emit('input', newValue)
		},
		disabled() {
			this.listaDeIds = []
			this.$forceUpdate()
		}
	},
	computed: {
		countActive() {
			return this.listaDeIds.length
		},
		filteredList() {
			if (!this.searchQuery) return this.lista;
			let query = this.searchQuery.toUpperCase();
			query = this.normalizeString(query)
			const regexp = new RegExp(query, 'g')
			return this.lista.filter((item) => {
				let value = String(item[this.chaveLista]).toUpperCase()
				value = this.normalizeString(value)
				return regexp.test(value)
			});
		}
	},
	methods: {
		normalizeString(str) {
		  return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toUpperCase();
		},
		clear() {
			this.lista = this.lista.map((item) => {
				return {...item, active: false}
			})
			this.listaDeIds = []
			this.$forceUpdate()
		},
		ativaOuDesativa(value) {
			const index = this.lista.findIndex((item) => {
				if (item[this.chaveValue] === value) {
					return true
				}
				return false 
			})
			const item = this.lista[index]
			let key = item[this.chaveValue]
			this.lista[index].active = !this.lista[index].active
			const indexLista = this.listaDeIds.indexOf(key)
			if (indexLista === -1) {
				this.listaDeIds.push(key)
			} else {
				this.listaDeIds.splice(indexLista, 1)
			}

			this.$forceUpdate();
		},

		setarAtivos(lista) {
			this.lista = lista.forEach((item) => {
				if (item.active) {
					this.listaDeIds.push(item.id)
				}
			})
		}
	}
}
</script>
<style scoped>
.botaoSelect {
	line-height: 1px;
	display: flex;
	align-items: center;
	justify-content: center;
	height: 28px;
}
.divSelect {
	display: flex;
	align-items: center;
	justify-content: center;
	width: 16px;
	height: 16px;
	line-height: 16px;
	cursor: pointer;
	font-size: 10px;
	border-radius: 50%;
	margin-right: 8px;
	background: #f0ad4e;
	color: white;
}
</style>